export const docFileFormatsRegexp = new RegExp(
  /\.(?:image|jpg|JPG|jpeg|gif|GIF|doc|DOC|pdf|PDF|png|PNG|docx|xls|xlsx)/
);
